import axios, { InternalAxiosRequestConfig } from 'axios';
import { DefaultApi } from '../../client-sdk/api';

export const createHimmaClient = (baseUrl: string): DefaultApi => {
  const axiosInstance = axios.create();

  axiosInstance.interceptors.request.use(
    async (
      config: InternalAxiosRequestConfig<any>
    ): Promise<InternalAxiosRequestConfig<any>> => {
      const userDataString = localStorage.getItem('userData');

      if (userDataString) {
        try {
          const userData = JSON.parse(userDataString);
          const userId = userData.userId;
          const token = userData.token;

          if (token && userId) {
            config.headers.Authorization = `Bearer ${token}`;
            config.headers.userId = userId;
          } else {
            config.headers.Authorization = 'Bearer';
          }
        } catch (error) {
          console.error('Error parsing userData:', error);
          config.headers.Authorization = 'Bearer';
        }
      } else {
        config.headers.Authorization = 'Bearer';
      }

      return config;
    }
  );

  axiosInstance.interceptors.response.use(
    (response) => response,
    async (error) => {
      const status = error?.response?.status;
      const originalRequest = error?.config as InternalAxiosRequestConfig & { _retry?: boolean };

      if (status === 401) {
        try {
          // If there's a newer token in localStorage (e.g., another tab logged in), retry once with it
          if (!originalRequest?._retry) {
            const stored = localStorage.getItem('userData');
            if (stored) {
              const parsed = JSON.parse(stored);
              const latestToken = parsed?.token;
              const currentAuthHeader: string | undefined = (originalRequest.headers as any)?.Authorization as any;
              const currentToken = currentAuthHeader?.startsWith('Bearer ')
                ? currentAuthHeader.slice('Bearer '.length)
                : undefined;

              if (latestToken && latestToken !== currentToken) {
                originalRequest._retry = true;
                (originalRequest.headers as any).Authorization = `Bearer ${latestToken}`;
                return axiosInstance(originalRequest);
              }
            }
          }

          // No newer token available or retry already attempted → log out
          localStorage.removeItem('userData');
        } catch (_) {
          // no-op
        }

        if (typeof window !== 'undefined') {
          window.location.hash = '/';
        }
      }

      return Promise.reject(error);
    }
  );

  return new DefaultApi(undefined, baseUrl, axiosInstance);
};
